import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function GameLobby() {
  const { user, logout } = useAuth();
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const filters = [
    { id: 'all', label: 'All Games', icon: 'ri-gamepad-line' },
    { id: 'slots', label: 'Slots', icon: 'ri-slot-machine-line' },
    { id: 'jackpot', label: 'Jackpot', icon: 'ri-trophy-line' },
    { id: 'new', label: 'New Games', icon: 'ri-star-line' },
  ];

  const games = [
    {
      id: 1,
      title: 'Mega Fortune',
      provider: 'NetEnt',
      category: 'jackpot',
      image: 'https://readdy.ai/api/search-image?query=luxurious%20golden%20fortune%20wheel%20with%20diamonds%20and%20gold%20coins%20on%20elegant%20dark%20background%2C%20casino%20slot%20game%20style%2C%20premium%20quality%2C%20vibrant%20colors%2C%20professional%20lighting&width=400&height=300&seq=game1&orientation=landscape',
      jackpot: '$2,450,000'
    },
    {
      id: 2,
      title: 'Starburst',
      provider: 'NetEnt',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=colorful%20cosmic%20starburst%20with%20glowing%20gems%20and%20stars%20on%20dark%20space%20background%2C%20casino%20slot%20game%20style%2C%20vibrant%20neon%20colors%2C%20professional%20lighting&width=400&height=300&seq=game2&orientation=landscape'
    },
    {
      id: 3,
      title: 'Book of Dead',
      provider: 'Play\'n GO',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=ancient%20egyptian%20golden%20book%20with%20hieroglyphics%20and%20mystical%20symbols%20on%20dark%20temple%20background%2C%20casino%20slot%20game%20style%2C%20rich%20gold%20colors%2C%20professional%20lighting&width=400&height=300&seq=game3&orientation=landscape'
    },
    {
      id: 4,
      title: 'Gonzo\'s Quest',
      provider: 'NetEnt',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=ancient%20aztec%20golden%20mask%20and%20treasures%20in%20jungle%20ruins%20on%20dark%20background%2C%20casino%20slot%20game%20style%2C%20adventure%20theme%2C%20professional%20lighting&width=400&height=300&seq=game4&orientation=landscape'
    },
    {
      id: 5,
      title: 'Divine Fortune',
      provider: 'NetEnt',
      category: 'jackpot',
      image: 'https://readdy.ai/api/search-image?query=greek%20mythology%20golden%20pegasus%20and%20ancient%20columns%20on%20dark%20mystical%20background%2C%20casino%20slot%20game%20style%2C%20divine%20theme%2C%20professional%20lighting&width=400&height=300&seq=game5&orientation=landscape',
      jackpot: '$1,850,000'
    },
    {
      id: 6,
      title: 'Immortal Romance',
      provider: 'Microgaming',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=gothic%20vampire%20castle%20with%20red%20roses%20and%20mysterious%20atmosphere%20on%20dark%20background%2C%20casino%20slot%20game%20style%2C%20romantic%20dark%20theme%2C%20professional%20lighting&width=400&height=300&seq=game6&orientation=landscape'
    },
    {
      id: 7,
      title: 'Mega Moolah',
      provider: 'Microgaming',
      category: 'jackpot',
      image: 'https://readdy.ai/api/search-image?query=african%20safari%20golden%20lion%20with%20savanna%20sunset%20on%20dark%20background%2C%20casino%20slot%20game%20style%2C%20majestic%20wildlife%20theme%2C%20professional%20lighting&width=400&height=300&seq=game7&orientation=landscape',
      jackpot: '$5,200,000'
    },
    {
      id: 8,
      title: 'Thunderstruck II',
      provider: 'Microgaming',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=norse%20mythology%20thor%20hammer%20with%20lightning%20and%20storm%20clouds%20on%20dark%20background%2C%20casino%20slot%20game%20style%2C%20epic%20thunder%20theme%2C%20professional%20lighting&width=400&height=300&seq=game8&orientation=landscape'
    },
    {
      id: 9,
      title: 'Dead or Alive',
      provider: 'NetEnt',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=wild%20west%20cowboy%20sheriff%20badge%20and%20revolvers%20on%20dark%20desert%20background%2C%20casino%20slot%20game%20style%2C%20western%20theme%2C%20professional%20lighting&width=400&height=300&seq=game9&orientation=landscape'
    },
    {
      id: 10,
      title: 'Reactoonz',
      provider: 'Play\'n GO',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=cute%20colorful%20alien%20creatures%20with%20glowing%20eyes%20in%20space%20on%20dark%20background%2C%20casino%20slot%20game%20style%2C%20fun%20cartoon%20theme%2C%20professional%20lighting&width=400&height=300&seq=game10&orientation=landscape'
    },
    {
      id: 11,
      title: 'Wolf Gold',
      provider: 'Pragmatic Play',
      category: 'jackpot',
      image: 'https://readdy.ai/api/search-image?query=majestic%20golden%20wolf%20howling%20at%20full%20moon%20in%20canyon%20on%20dark%20background%2C%20casino%20slot%20game%20style%2C%20wildlife%20theme%2C%20professional%20lighting&width=400&height=300&seq=game11&orientation=landscape',
      jackpot: '$980,000'
    },
    {
      id: 12,
      title: 'Sweet Bonanza',
      provider: 'Pragmatic Play',
      category: 'slots',
      image: 'https://readdy.ai/api/search-image?query=colorful%20candy%20land%20with%20lollipops%20and%20fruits%20on%20dark%20background%2C%20casino%20slot%20game%20style%2C%20sweet%20theme%2C%20vibrant%20colors%2C%20professional%20lighting&width=400&height=300&seq=game12&orientation=landscape'
    }
  ];

  const filteredGames = games.filter(game => {
    const matchesFilter = activeFilter === 'all' || game.category === activeFilter;
    const matchesSearch = game.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         game.provider.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0D0E11] via-[#111319] to-[#16181D]">
      {/* Header */}
      <header className="bg-[#1a1c24] border-b border-[#FFD349]/20 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            {/* Logo & Mobile Balance */}
            <div className="flex flex-col gap-2">
              <Link to="/" className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-slot-machine-line text-[#FFD349] text-2xl"></i>
                </div>
                <h1 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-[#FFD349] to-[#FFC107] bg-clip-text text-transparent" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                  DIGITWISE
                </h1>
              </Link>
              
              {/* Mobile Balance - Below Logo */}
              {user && (
                <div className="md:hidden flex items-center justify-center gap-1 bg-[#0D0E11] border border-[#FFD349]/20 rounded px-3 py-1.5 mx-auto w-fit">
                  <i className="ri-wallet-3-line text-[#FFD349] text-sm"></i>
                  <span className="text-white font-semibold text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    ${user.balance.toLocaleString()}
                  </span>
                </div>
              )}
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-6">
              <Link to="/" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Home
              </Link>
              <Link to="/dashboard" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Dashboard
              </Link>
              <Link to="/game-lobby" className="text-[#FFD349] text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Games
              </Link>
              <Link to="/wallet" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Wallet
              </Link>
              <Link to="/vip" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                VIP
              </Link>
              <Link to="/profile" className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                Profile
              </Link>
            </nav>

            {/* Desktop Balance & Logout */}
            <div className="hidden md:flex items-center gap-4">
              <div className="flex items-center gap-3 bg-[#0D0E11] border border-[#FFD349]/30 rounded-lg px-4 py-2">
                <i className="ri-wallet-3-line text-[#FFD349] text-lg"></i>
                <div>
                  <p className="text-white/60 text-xs" style={{ fontFamily: 'Montserrat, sans-serif' }}>Balance</p>
                  <p className="text-[#FFD349] font-bold text-lg" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                    ${user?.balance.toLocaleString() || '0'}
                  </p>
                </div>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden text-white p-2 hover:text-[#FFD349] transition-colors cursor-pointer"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pt-4 border-t border-[#FFD349]/20">
              <nav className="flex flex-col gap-3">
                <Link
                  to="/"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-home-line mr-2"></i>
                  Home
                </Link>
                <Link
                  to="/dashboard"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-dashboard-line mr-2"></i>
                  Dashboard
                </Link>
                <Link
                  to="/game-lobby"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#FFD349] text-sm font-medium py-2 px-4 rounded-lg bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-gamepad-line mr-2"></i>
                  Games
                </Link>
                <Link
                  to="/wallet"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-wallet-3-line mr-2"></i>
                  Wallet
                </Link>
                <Link
                  to="/vip"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-vip-crown-line mr-2"></i>
                  VIP
                </Link>
                <Link
                  to="/profile"
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-white/80 hover:text-[#FFD349] transition-colors text-sm font-medium py-2 px-4 rounded-lg hover:bg-[#0D0E11] cursor-pointer"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-user-line mr-2"></i>
                  Profile
                </Link>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-2" style={{ fontFamily: 'Orbitron, sans-serif' }}>
            Game Lobby
          </h2>
          <p className="text-white/60 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            Choose from thousands of exciting games
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-6">
          <div className="relative max-w-md">
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search games..."
              className="w-full bg-[#1a1c24] border border-[#FFD349]/30 rounded-lg px-4 py-3 pl-12 text-white text-sm focus:outline-none focus:border-[#FFD349] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            />
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-white/50 text-lg"></i>
          </div>
        </div>

        {/* Filters */}
        <div className="mb-8 overflow-x-auto">
          <div className="flex gap-3 min-w-max pb-2">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
                  activeFilter === filter.id
                    ? 'bg-gradient-to-r from-[#FFD349] to-[#FFC107] text-black'
                    : 'bg-[#1a1c24] text-white/80 hover:bg-[#1a1c24]/80 border border-[#FFD349]/20'
                }`}
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                <i className={`${filter.icon} text-lg`}></i>
                {filter.label}
              </button>
            ))}
          </div>
        </div>

        {/* Games Grid */}
        {filteredGames.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredGames.map((game) => (
              <div
                key={game.id}
                className="bg-[#1a1c24] border border-[#FFD349]/20 rounded-xl overflow-hidden group hover:border-[#FFD349] transition-all duration-300 hover:shadow-[0px_0px_20px_rgba(255,211,73,0.3)] cursor-pointer"
              >
                {/* Game Image */}
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={game.image}
                    alt={game.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                  />
                  {game.jackpot && (
                    <div className="absolute top-3 right-3 bg-gradient-to-r from-[#FFD349] to-[#FFC107] text-black px-3 py-1 rounded-full text-xs font-bold" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                      {game.jackpot}
                    </div>
                  )}
                  {/* Play Overlay */}
                  <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <button className="bg-gradient-to-r from-[#FFD349] to-[#FFC107] text-black px-8 py-3 rounded-lg font-bold text-sm hover:shadow-[0px_0px_20px_rgba(255,211,73,0.6)] transition-all whitespace-nowrap" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      <i className="ri-play-fill mr-2"></i>
                      Play Now
                    </button>
                  </div>
                </div>

                {/* Game Info */}
                <div className="p-4">
                  <h3 className="text-white font-bold text-lg mb-1" style={{ fontFamily: 'Orbitron, sans-serif' }}>
                    {game.title}
                  </h3>
                  <p className="text-white/60 text-sm" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {game.provider}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <i className="ri-gamepad-line text-white/20 text-6xl mb-4"></i>
            <p className="text-white/60 text-lg" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              No games found
            </p>
            <p className="text-white/40 text-sm mt-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Try adjusting your search or filters
            </p>
          </div>
        )}
      </main>
    </div>
  );
}
